import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import {
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from "@fluentui/react-components";
import {
  InfoRegular,
  MoreHorizontal28Filled,
  SettingsRegular,
} from "@fluentui/react-icons";
import { useState } from "react";

import { useLayoutStore } from "../../store/layout.store.js";

export const ShowMorePopover = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { setModalVariant } = useLayoutStore();
  const handleSelect = (variant: "info" | "settings-user") => {
    setModalVariant(variant);
    setIsOpen(false);
  };
  const handleClick56 = useStableCallback(() => handleSelect("info"));

  const handleClick46 = useStableCallback(() => handleSelect("settings-user"));
  const handleClick43 = useStableCallback((event) => event.stopPropagation());

  const handleOpenChange28 = useStableCallback((_event, data) =>
    setIsOpen(data.open)
  );

  return (
    <Popover onOpenChange={handleOpenChange28} open={isOpen}>
      <PopoverTrigger disableButtonEnhancement>
        <button
          className="flex cursor-pointer flex-col items-center border-0 bg-transparent p-0 select-none"
          type="button"
        >
          <MoreHorizontal28Filled className="h-[30px]" />
          More
        </button>
      </PopoverTrigger>

      <PopoverSurface
        data-blocks-hover="true"
        onClick={handleClick43}
        tabIndex={-1}
      >
        <ul className="space-y-2">
          <li>
            <button
              className="hover:text-bzd-blue-500 flex w-full cursor-pointer items-center border-0 bg-transparent p-0 text-left text-xs font-semibold transition-colors"
              onClick={handleClick46}
              type="button"
            >
              <SettingsRegular className="mr-1 text-xl" />
              Settings
            </button>
          </li>
          <li>
            <button
              className="hover:text-bzd-blue-500 flex w-full cursor-pointer items-center border-0 bg-transparent p-0 text-left text-xs font-semibold transition-colors"
              onClick={handleClick56}
              type="button"
            >
              <InfoRegular className="mr-1 text-xl" />
              Info
            </button>
          </li>
        </ul>
      </PopoverSurface>
    </Popover>
  );
};
